import * as React from 'react';
import './style.scss';
import InputLegacy from './InputLegacy';
import InputUpdated from './InputUpdated';

interface Props {
  name: string;
  value: string;
  placeholder?: string;
  title: string;
  className?: string;
  multiline?: boolean;
  error: string;
  onValueChange?: (value: string) => void;
  isLegacy?: boolean;
}

const Input: React.SFC<Props> = ({ isLegacy = true, ...props }) => {
  return isLegacy ? <InputLegacy {...props} /> : <InputUpdated {...props} />;
};

export default Input;
